module.exports = __webpack_public_path__ + "static/img/preview-04.01a6eff3.webp";